import { Backdrop, CircularProgress } from "@mui/material"
import { Button, Col, Popconfirm, Row, Table, TableProps, Typography } from "antd"
import { useEffect, useState } from "react"
import AdminLayout from "../../../component/AdminLayout"
import SearchBar from "../../../component/Search"
import { customSortDirections } from "../../../Utils/utils"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddRole from "../components/AddRole"
import { DeleteAppUserRole, GetAppUserRolesList, axiosErrorMessages } from "../../../API/api"
import { enqueueSnackbar } from "notistack"
import { SorterResult } from "antd/es/table/interface"
import axios, { AxiosError } from "axios"

type UserAppRoles = {
  userAppRoleId:number,
    employeeName: string,
    userRole: string
}

const AdminManagement = () => {
    
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [addNewUserRole,setAddNewUserRole] = useState<boolean>(false)
    const [isEdit,setIsEdit] = useState<boolean>(false)
    const [editData,setEditData] = useState([])
    const [userAppRoles,setUserAppRoles] = useState<UserAppRoles[]>([])
    const [filteredData, setFilteredData] = useState<UserAppRoles[]>([]);
    const [searchText, setSearchText] = useState("");
    const [sortedInfo, setSortedInfo] = useState<SorterResult<UserAppRoles>>({});

    useEffect(()=>{
      getUserAppRoles()
    },[])
    const getUserAppRoles = async () => {
      try {
        setIsLoading(true)
        const response = await GetAppUserRolesList();
        const newData = response.data.map((software: any, index: number) => ({
          ...software,
          key: software.userAppRoleId,
        })

      );
      setUserAppRoles(newData)
      setIsLoading(false)

      } catch (error:any) {
        let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    
        enqueueSnackbar("Error in fetching data",{ variant: 'error', anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },})
        setIsLoading(false)
      }
    }
    const handleSearch = (value:any) => {setCurrentPage(1);
      setSearchText(value);
      filterData(value);
    }

      const filterData = (searchText: string) => {
        if (!searchText) {
          setFilteredData([]);
        } else {
          const filtered = userAppRoles.filter((item: any) =>
            item.employeeName.toLowerCase().includes(searchText.toLowerCase())
          );
          setFilteredData(filtered);
        }
      };
    const handleAddNewUserRole = () => { setIsEdit(false); setAddNewUserRole(true)}
    const handleEdit = (rowData:any) => {
        setEditData(rowData)
        setIsEdit(true)
        setAddNewUserRole(true)
    }
    const handleDelete = (rowData:any) => {
      setIsLoading(true)
      DeleteAppUserRole(rowData.key)
                  .then((response:any)  =>  {
                    enqueueSnackbar("Deleted Successfully", {
                      variant: "success",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });

                    setIsLoading(false)
                    getUserAppRoles()
                  })
                  .catch((error:any)  =>  {
                  
                    enqueueSnackbar("Error in Deleting", {
                      variant: "error",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });
                    setIsLoading(false)

                  })
}
    const [currentPage,setCurrentPage] = useState<number>(1)
    const columns = [
        {
          title: "No",
          dataIndex: "id",
          key: "id",
          render: (text: any, record: any, index: number) =>
            (currentPage - 1) * 50 + index + 1,
        },
        {
          title: "Employee Name",
          dataIndex: "employeeName",
          key: "employeeName",
          sorter: (a: any, b: any) => a.employeeName.localeCompare(b.employeeName),
          sortOrder: sortedInfo.columnKey === "employeeName" ? sortedInfo.order : null,
          render: (text: string) => <div>{text}</div>,
        },
        {
            title: "Role",
            dataIndex: "userRole",
            key: "userRole",
            render: (text: string) => <div>{text}</div>,
          },
        {
          title: "Action",
          dataIndex: "action",
          render: (_: any, record: any) => {
            return (
              <>
                {" "}
                <Typography.Link onClick={() => handleEdit(record)}>
                  <EditOutlined />
                </Typography.Link>
                <Popconfirm
                  title="Do you want to delete the user role?"
                  onConfirm={() => handleDelete(record)}
                >
                  <Typography.Link className="delete-btn">
                    <DeleteOutlined />
                  </Typography.Link>
                </Popconfirm>
              </>
            );
          },
        },
      ];
      const closeAddPopup = () => {setAddNewUserRole(false); getUserAppRoles()}
      const handleChange: TableProps<UserAppRoles>["onChange"] = (
  
        pagination,
        filters,
        sorter
      ) => {
        setSortedInfo(sorter as SorterResult<UserAppRoles>);
      };
    return  <>
    {" "}
    <AdminLayout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <div className="employee-table-header ">
        <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px 0 16px"}}>
            <Col className="gutter-row" lg={12} sm={24}>
              <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                Admin Management
              </h3>
            </Col>
            <Col className="gutter-row pm-search-flex" lg={{span: 10, offset: 2}} sm={24} xs={24} style={{ display: "flex"}}>
              <SearchBar
                width={"100%"}
                onSearch={handleSearch}
                placeholder={"Search Employee"}
              />
              <Button
                onClick={handleAddNewUserRole}
                type="primary"
                style={{ marginLeft: 10 }}
                size="small"
              >
                Add New
              </Button>
            
            </Col>
          </Row>
        </div>

         <Table
          sortDirections={customSortDirections}
          className="status-list-admin"
          columns={columns}
          onChange={handleChange}
          size='small'

          rowClassName="editable-row"
          dataSource={searchText ? filteredData : userAppRoles}

        />
      </div>
     {addNewUserRole && (
       <AddRole isEdit={isEdit} editData={editData} closeAddPopup={closeAddPopup}/>
      )}
    </AdminLayout>
  </>
}   

export default AdminManagement